import { GET_ALL_NOTIFICATIONS, RESPONSE_STATUS, CLEAR_RESPONSE } from './notifyTypes'
export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_NOTIFICATIONS:
            return {
                ...state,
                all_notifications: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
